module.exports = "/assets/data/83a8ae0c5cf6395af3c56a5f181e905e-NE39.data.json";